import React from 'react';
import { Cloud, Flower2, Sparkles } from 'lucide-react';
import StylePickerShowcase from './StylePickerShowcase';

interface StylePickersPageProps {
  onSignUp?: () => void;
}

const StylePickersPage: React.FC<StylePickersPageProps> = ({ onSignUp }) => {
  return (
    <main className="relative z-10 flex-1">
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-sky-900/30 backdrop-blur-sm border border-sky-500/20 text-sky-300 rounded-full text-sm font-medium mb-6">
            <Cloud size={14} className="shrink-0" />
            Style pickers
          </div>
          <h1 className="text-3xl md:text-5xl font-bold text-slate-100 mb-4">
            Skies, flowers and plants
          </h1>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto">
            Click a card to see the same pickers you use in PhotoClear — blue sky and sunset fans, plus flower and plant type circles.
          </p>
        </div>

        <div className="max-w-4xl mx-auto overflow-x-clip pb-8">
          <StylePickerShowcase />
        </div>

        {onSignUp && (
          <div className="flex justify-center mt-10">
            <button
              onClick={onSignUp}
              className="group flex items-center gap-3 px-10 py-5 bg-gradient-to-r from-blue-600 to-cyan-500 hover:brightness-110 text-white rounded-2xl font-semibold text-lg transition-all shadow-xl shadow-blue-900/40 border border-blue-400/30"
            >
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-blue-600 group-hover:rotate-[360deg] transition-transform duration-700">
                <Sparkles size={20} strokeWidth={2} />
              </span>
              Try these on a listing photo
            </button>
          </div>
        )}

        <p className="text-center text-xs text-slate-500 mt-6 flex items-center justify-center gap-1.5">
          <Flower2 size={12} />
          This page is a preview — sign in to apply a style to a real photo.
        </p>
      </div>
    </main>
  );
};

export default StylePickersPage;
